import formatDate from "mn-utils/formatDate";

const React = require('react');
const c3 = require('c3');
const d3 = require('d3');

import 'c3/c3.css';
import './styles.scss';

module.exports = () => {
  const data = [
    {date: new Date("2015-11-21"), regPay: 200, commission: 50},
    {date: new Date("2015-11-22"), regPay: 200, commission: 50},
    {date: new Date("2015-11-23"), regPay: 200, commission: 50},
    {date: new Date("2015-11-24"), regPay: 200, commission: 50},
    {date: new Date("2015-11-25"), regPay: 200, commission: 50},
    {date: new Date("2015-11-26"), regPay: 200, commission: 50},
    {date: new Date("2015-11-27"), regPay: 200, commission: 50},
    {date: new Date("2015-11-28"), regPay: 200, commission: 50},
    {date: new Date("2015-11-29"), regPay: 200, commission: 50},
    {date: new Date("2015-11-30"), regPay: 200, commission: 50},
    {date: new Date("2015-11-31"), regPay: 200, commission: 50},
    {date: new Date("2015-11-32"), regPay: 200, commission: 50},
  ];

  const date = ['date'];
  const regPay = ['regPay'];
  const commission = ['commission'];

  data.forEach((el) => {
    date.push(el.date);
    regPay.push(el.regPay);
    commission.push(el.commission);
  });

  const c3Data = [date, regPay, commission];

  const names = {
    regPay: 'Regular Pay',
    commission: 'Commission'
  }

  React.useEffect(() => {
    const chart = c3.generate({
      bindto: "#chart",
      padding: {
        left: 30,
        right: 0,
        bottom: 0
      },
      data: {
        x: 'date',
        xFormat: '%Y-%m-%d',
        columns: c3Data,
        names,
        groups: [
          ['regPay', 'commission'],
        ],
        type: "bar",
        order: 'asc',
        colors: {
          regPay: '#3E4044',
          commission: '#2CE889',
        },
      },
      bar: {
        width: 27,
        space: 0
      },
      axis: {
        x: {
          show: false,
          type: 'timeseries',
          tick: {
            format: '%Y-%m-%d', // how the date is displayed
            centered: true
          }
        },
      },
      grid: {
        x: {
          show: false
        },
        y: {
          show: true,
        }
      },
      legend: {
        show: false
      },
      tooltip: {
        position: function (data, width, height, element) {
          const activeBlock = document.querySelector('._expanded_');
          const chartBlock = document.querySelector('.ref-chart__wrapper');

          if (!activeBlock) return {};

          const {x: columnBlockX, width: activeBlockWidth} = activeBlock.getBoundingClientRect();
          const {x: chartBlockX} = chartBlock.getBoundingClientRect();

          return {
            top: 0 - height + 10,
            left: columnBlockX - chartBlockX + 30 - width / 2 - activeBlockWidth / 2
          };
        },
        contents: function (d, ...rest) {
          const [regPay, commission] = d;
          const date = regPay.x;

          return `
            <div class="ref-chart__tooltip">
              <div class="ref-chart__tooltip-header">${formatDate(date, 'dd.mm.yyyy')}</div>
              <div class="ref-chart__tooltip-data">
                <span>$ ${regPay.value}</span>
                <span>$ ${commission.value}</span>
              </div>
              <div class="ref-chart__tooltip-triangle" />
            </div>
          `
        }
      }
    });

    d3.select('.ref-chart__legend').selectAll('span')
      .data(['regPay', 'commission'])
      .enter().append('span')
      .attr('class', 'ref-chart__legend-item')
      .attr('data-id', function (id) { return id; })
      .html(function (id) { return names[id] || id; })
      .each(function (id) {
        // d3.select(this).style('background-color', chart.color(id));
      })
      .on('mouseover', function (id) {
        chart.focus(id);
      })
      .on('mouseout', function (id) {
        chart.revert();
      })
      .on('click', function (id) {
        chart.toggle(id);

        const node = d3.select(this);
        node.classed('disabled', !node.attr('class').includes('disabled'));
      });
  }, []);

  return (
    <div className="ref-chart__wrapper">
      <div id="chart" />
      <div className="ref-chart__border" />
    </div>
  );
}